<script setup lang="ts">
import GreeterBox from "../components/GreeterBox.vue";
import {
  useContextStore,
  useGroupingStore,
  usePeopleStore,
} from "../data/store.ts";
import { computed, ref } from "vue";
import GroupBuilder from "../components/GroupBuilder.vue";
import GroupTable from "../components/GroupTable.vue";

const people = usePeopleStore();
const groups = useGroupingStore();
const context = useContextStore();

const editMode = ref<boolean>(false);
const hoveredMember = ref<string | null>(null);

const canEditGroup = computed(
  () => groups.group?.owner === context.user || groups.activeGroup === "NEW",
);
</script>

<template>
  <div>
    <GreeterBox>
      Find your group using filters.
      <div class="row justify-content-center mb-2">
        <div class="col-lg-4 col-md-8 col text-start">
          <div class="row g-1">
            <div :class="canEditGroup ? 'col-10' : 'col-12'">
              <select
                id="grpsel"
                v-model="groups.activeGroup"
                class="form-select"
                aria-label="Default select example"
                @change="editMode = false"
              >
                <option v-for="g in groups.groups" :value="g.id" :key="g.id">
                  {{ g.name }}
                </option>
                <option value="NEW">Create new group</option>
              </select>
            </div>
            <div v-if="canEditGroup" class="col-2">
              <button
                class="btn"
                :class="{ 'btn-outline-secondary': editMode }"
                style="white-space: nowrap; --bs-btn-padding-y: 0.3rem"
                @click="editMode = !editMode"
              >
                <i class="bi-pencil" />&nbsp;Edit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-8 col small text-muted">
          <div style="font-size: 0.6em" v-if="groups.group?.owner">
            Maintainer:
            {{ people.people?.[groups.group.owner]?.name ?? "[DELETED]" }}
          </div>
          <ul class="list-inline">
            <li
              v-for="u in groups.group?.people"
              :key="u"
              class="list-inline-item"
              @mouseover="hoveredMember = u"
              @touchstart="hoveredMember = u"
              @mouseleave="hoveredMember = null"
            >
              {{ people.people?.[u]?.name ?? "[DELETED]" }}
              <sup style="top: -1em; font-size: 0.5em"
                >({{ people.people?.[u]?.acro ?? "DEL" }})</sup
              >
            </li>
          </ul>
        </div>
      </div>
    </GreeterBox>

    <GroupBuilder v-if="editMode" />

    <GroupTable
      :people="groups.group?.people ?? []"
      :highlight="hoveredMember"
    />
  </div>
</template>
